import { Booking } from "../../../../APIDocs/apiTypes"
import { Card } from "../../components/Card";
import { Label } from "../../components/Label";
import { useFeedbackColour, useFeedbackColourForBookingStatus } from "../../hooks/useFeedbackColour";

interface KeyJobDetailsProps {
    booking: Booking
}

export const KeyJobDetailsCard = ({ booking }: KeyJobDetailsProps) => {
    const [borderClass, ] = useFeedbackColour(useFeedbackColourForBookingStatus(booking.Status))
    return (
        <Card identifier="keyJobDetails" className={`h-min px-4 py-2 border-b-4 ${borderClass}`}>
            <div className="flex flex-row items-center justify-between pr-6">
                <Label title="Booking ID" text={`${booking.BookingId}`} />
                <Label title="MPAN" text={booking.Mpan} />
                <Label title="Current Job Status" text={booking.Status} />
                <Label title="Booked Job" text={booking.JobTypeDesc} className="col-span-2"/>
                <Label title="Job Status ID" text={booking.JobStatusId} />
                <Label title="Site MPID" text={booking.SiteMpid} />
                <Label title="Source MPID" text={booking.SourceMpid ?? 'None'} />
            </div>
        </Card>
    )
}
